<main class="o-layout__wrapper--full">
  <ls-iframe [page]="'waiter-mobile.html'"></ls-iframe>
</main>
